import { Component, OnInit, Input, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { localDataService } from '../../Services/localDataServices';


declare var $: any;  //定义jquery
declare var async: any;  //定义jquery
@Component({
  selector: 'sealNumber',
  providers: [localDataService],
  templateUrl: './sealNumber.html',
})


export class sealNumberComponent implements OnInit {

  status: any;
  set: any ;
  imgUrl: string;
  scoreUrl: string;
  _id: any;
  n: number;
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _localDataService: localDataService,
    private _location: Location,
  ) { }

  ngOnInit() {
    let pthis = this;
    this.n = 0;
    var a = setInterval(function () {
      if (pthis.n > 180) {
        clearInterval(a);
        this.n = "超时！"
        return false;
      }
      pthis._localDataService.apiCommon('/S0002/details',{orderNo:pthis._activatedRoute.snapshot.url[1].path})
        .then(data => {
          pthis.status = data;
          pthis.n++;
          if (pthis.status.status) {
            clearInterval(a);
            pthis.getdata(pthis._activatedRoute.snapshot.url[1].path)
          } else {
            $(".djs").show()
          }
        }).catch(err => { console.log(err); });
    }, 1000)

  }

  pcmessage: string;
  zxd: any;
  setvalue:any;
  setpath:any;
  getdata(orderNo) {
    $(".djs").hide()
    this._localDataService.apiCommon('/S0002/details',{orderNo:orderNo})
      .then(data => {
        this.status = data;
        if (this.status.status) {
          this.set = this.status.data;
          this.setvalue = this.set.fileList[0].aiJson.seal_code[0].item_string;
          this.setpath = this.set.fileList[0].fileName
        } else {}
      }).catch(err => { console.log(err); });
  }


  

  changeTab(i) {
    $(".tib").css("background", "#fff").eq(i).css("background", "#eee")
    $(".tibcontant").css("display", "none").eq(i).css("display", "block")
  }

  closepcmsg() {
    $(".hullabaloo").fadeOut()
  }

  

  wwwidth(type, event) {
    let obj = $(event.target).parent().find('img');
    let SDcanvas = $(event.target).parent().find('.SDcanvas');

    let ww = Number(obj.width())
    if (type == 1) {
      ww = ww + 80
    } else {
      ww = ww - 80
    }

    obj.css("width", ww + "px")
  
  }


}



// WEBPACK FOOTER //
// /srv/jenkins-test/workspace/dev-doc-web/src/app/component/sealNumber/sealNumber.ts